// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  AssetCategory,
} from "./types";

export default {
  requestId: __t.u128(),
  name: __t.string(),
  scope: __t.string(),
  get category() {
    return AssetCategory;
  },
  description: __t.string(),
  tags: __t.string(),
  thumbnailUrl: __t.option(__t.string()),
  format: __t.option(__t.string()),
};
